import {Component, OnInit} from '@angular/core';
import { ModalExtended } from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs/Rx';
import {BeeztelCodesService} from '../../services/beeztel-codes.service';

import Swal from "sweetalert2";
import {AuthService} from '../../../../../core/service/auth.service';

@Component({
  selector: 'app-beeztel-codes-edit',
  templateUrl: './beeztel-codes-edit.component.html',
  styleUrls: ['./beeztel-codes-edit.component.scss']
})
export class BeeztelCodesEditComponent extends ModalExtended implements OnInit {

    data: any;
    formData: FormGroup;

    status: any = [];
    statusDoi: any = [];
    submitted: boolean = false;
    enabled: boolean = false;

    constructor(private codesHandler: BeeztelCodesService, private auth: AuthService) {
        super();
        this.formData = new FormGroup(
            {
                code: new FormControl('', Validators.required),
                dialstatus: new FormControl(''),
                status: new FormControl('', Validators.required),
                status_doi: new FormControl(''),
                check_on_alert: new FormControl('0'),
                all_portals: new FormControl('0'),
                description: new FormControl(''),
                service_campaign_pk: new FormControl()
            }
        );
    }

    createMappingCode(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var formValues = this.codesHandler.parseDataForCreate(this.formData.value, this.auth.getPortalSelected().portal);
        this.codesHandler.postNewCode(formValues).subscribe(
            (result) => {
                Swal({type: 'success', title: 'Action performed', text: 'New mapping code created successfully'});
                this.enabled = false;
            }
        )
    }

    updateMappingCode(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var formValues = this.codesHandler.parseDataForUpdate(this.formData.value, this.data.object.pk);
        this.codesHandler.putExistingCode(formValues).subscribe(
            (result) => {
                Swal({type: 'success', title: 'Action performed', text: 'Existing code has been update successfully'});
                this.enabled = false;
            }
        )
    }

    onExit(): void {
        this.applyCallback('lele');
        this.close();
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('object')){
            this.formData.controls['code'].setValue(this.data.object.code);
            this.formData.controls['dialstatus'].setValue(this.data.object.dialstatus);
            this.formData.controls['status'].setValue(this.data.object.status);
            this.formData.controls['status_doi'].setValue(this.data.object.status_doi);
            this.formData.controls['check_on_alert'].setValue(this.data.object.check_on_alert);
            this.formData.controls['description'].setValue(this.data.object.description);
            this.formData.controls['service_campaign_pk'].setValue(this.data.object.service_campaign_pk);
        }

        Observable
            .forkJoin(this.codesHandler.getStatusList(), this.codesHandler.getStatusDoiList())
            .subscribe(
                (results) => {
                    const [listStatus, listStatusDoi] = results;
                    this.status = listStatus;
                    this.statusDoi = listStatusDoi;

                    this.statusDoi = this.statusDoi.filter( (o) => { return o.id != 'DOI_LINE_WHATSAPP'; });
                }
            )
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/modals/beeztel-codes-edit/beeztel-codes-edit.component.ts